import React from 'react'
import "./header3.scss";
import { useNavigate } from "react-router-dom";

function Header3() {
    const navigate = useNavigate();
    return (
      <div className="navbar">
            <div onClick={() => navigate("/")} className='centerLogo'>
                <div className="logo">{/* <img src={logo} alt="logo" /> */}</div>
                <div className="name"></div>
            </div>
      </div>
    );
}

export default Header3